import {createSetters} from 'map-state-vmodel'

// initial state
const state = {
  option: false,
  optionMenus: [
    { name: 'My Page', path: '/mypage'},
    { name: 'Membership', path: '/membership'}
  ],
  notification: false,
  searchBox: false,
  searchResult: []
};

// getters
const getters = {};

// actions
const actions = {};

// mutations
const mutations = {
  ...createSetters(state)
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
